import {
  Box, Heading, Text, Button, VStack, SimpleGrid, Stack, List, ListItem, ListIcon,
  useColorMode, Image, useColorModeValue, HStack, Link, Divider, Badge, Flex, Icon,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { CheckCircleIcon, InfoOutlineIcon, ArrowRightIcon } from "@chakra-ui/icons";
import {
  UserPlus, BookOpen, CalendarClock, FileCheck2, PenTool,
  BarChart3, FolderLock, ShieldCheck, ClipboardList, Timer,TrendingUp,Shuffle,Layers,
  Layers3, LineChart, CreditCard, GraduationCap,
} from "lucide-react";
import NavBarTech from "./NavBarTech";
import TechLayout from "./TechLayout";
import bandpic from "../resources/Eduvic Technologies Final.png";
// import bandpicMob from "../resources/eduvic-tech-bg-mobile.png";
import bandpicMob from "../resources/Eduvic Technologies2.png";
import bandpicPlatform from "../resources/Eduvic Learning Platform.png";
import bandpic3 from "../resources/pexels-francesco-ungaro-96381.jpg";
import bandpic2 from "../resources/Eduvic Practice Platform.png";
import bandpic4 from "../resources/Eduvic Assessment Engine2.png";

import vnpic from "./resources/vnpic.png";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import EduvicUSP from "./Components/EduvicUSP";
import { AspectRatio } from "@chakra-ui/react";
import { CaseStudyCard } from "./Components/CaseStudyCard";
import { ProductAttributeCard } from "./Components/ProductAttributeCard"; // NEW — adjust path as needed
import { companyConfig } from "../config/company"; // NEW — adjust path to match your actual location

const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 6000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: false,
};

const LandingPageTech: React.FC = () => {
  const navigate = useNavigate();

  const contactusPhone = process.env.REACT_APP_CONTACTUS_PHONE;
  if (!contactusPhone) {
    throw new Error('REACT_APP_CONTACTUS_PHONE is not defined');
  }

  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const yOffset = -80;
        const yPosition = el.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: yPosition, behavior: "smooth" });
      }
    }
  }, [hash]);

  // ── Eduvic Practice Platform (B2C) — attribute groups ──
  const practiceAttributes = [
    {
      icon: Layers3,
      title: "Structured Practice Content",
      points: [
        "Practice Sets organized into Sections, Groups, and Question Sets.",
        "Covers Selective Entry, NAPLAN, ACER, EduTest, and HAST.",
      ],
    },
    {
      icon: ClipboardList,
      title: "Mock Exams",
      points: [
        "Multiple question sets combined with subject-specific breaks.",
        "Mirrors real exam-day conditions, not just a timed quiz.",
      ],
    },
    {
      icon: PenTool,
      title: "Writing & Manual Marking",
      points: [
        "Writing prompts scored by real markers, not auto-graded.",
        "Marked results relayed back to the student with feedback.",
      ],
    },
    {
      icon: Timer,
      title: "Timed & Untimed Modes",
      points: [
        "Configurable independently at section, group, or question-set level.",
        "Lets a student build pace gradually before going fully timed.",
      ],
    },
    {
      icon: LineChart,
      title: "Analytics & Review",
      points: [
        "Trend analytics per question set across multiple attempts.",
        "Full topic-wise and question-level attempt review.",
      ],
    },
    {
      icon: CreditCard,
      title: "Payments & Access",
      points: [
        "Stripe-integrated checkout, multiple entitlements per student.",
        "Discount coupons at both institute and individual-student level.",
      ],
    },
  ];

  // ── Eduvic Learning Platform (B2B) — attribute groups ──
const learningAttributes = [
  {
    icon: UserPlus,
    title: "Enrolment & Onboarding",
    points: [
      "Public and admin-led enrolment — online and offline students.",
      "Tutor onboarding and batch-tutor mapping built in.",
    ],
  },
  {
    icon: BookOpen,
    title: "Courses, Terms & Batches",
    points: [
      "Course, Term, and Class structuring with Batch formation.",
      "Designed around the practical workflows of organisations running structured learning programmes.",
    ],
  },
  {
    icon: CalendarClock,
    title: "Calendar & Scheduling",
    points: [
      "Student calendar with integrated Google Meet class links.",
      "Exams appear on the same calendar as classes.",
    ],
  },
  {
    icon: FileCheck2,
    title: "Exam Engine",
    points: [
      "Multi-question-set exams, shuffled per attempt at question and choice level.",
      "Cloze Dropdown, Cloze Gap-Fill, MCQ, and manually-marked formats — hybrid in one set.",
    ],
  },
  {
    icon: BarChart3,
    title: "Scoring & Analytics",
    points: [
      "Tutor/assessor delegation with a dedicated marking queue and admin override.",
      "Configurable scoring — partial credit, penalties, normalized modes.",
      "Topic-wise analytics with a full result finalization and publishing workflow.",
    ],
  },
  {
    icon: FolderLock,
    title: "Content Delivery",
    points: [
      "Staged lesson, summary, and assignment access, gated by schedule.",
      "Institutes connect their own Google Drive — content stays theirs, we gate access to it.",
    ],
  },
  {
    icon: ShieldCheck,
    title: "Tenant Admin Console",
    points: [
      "Full user management, subscription and onboarding oversight.",
      "Student self-service — support tickets, profile updates — without admin load.",
    ],
  },
];

  return (
    <TechLayout>
      <Box bg="black" color="white">

        <Box as="section" maxWidth={"1000px"} mx="auto" p={10}>
          <Box 
      //    display={{ base: "none", md: "block" }}
          >
            <Slider {...carouselSettings}>
              <AspectRatio ratio={16 / 9} width="100%">
                <Box
                  bgImage={bandpic}
                  bgSize="contain"
                  bgPos="center"
                  bgRepeat="no-repeat"
                  bgColor="black"
                  position="relative"
                  w="100%"
                  h="100%"
                >
                </Box>
              </AspectRatio>

              <AspectRatio ratio={16 / 9} width="100%">
                <Box
                  bgImage={bandpic2}
                  bgSize="contain"
                  bgPos="center"
                  bgRepeat="no-repeat"
                  bgColor="black"
                  position="relative"
                  w="100%"
                  h="100%"
                >
                  <Box
                    position="absolute"
                    bottom="5%"
                    left="5%"
                    bg="rgba(0, 0, 0, 0.6)"
                    p={6}
                    borderRadius="md"
                    maxW="lg"
                  >
{/*                     <Heading color="white" size="2xl">Eduvic Practice Platform</Heading>
                    <Text color="white" size="md" mt={2}>
                      Exam-realistic practice testing for Selective Entry, NAPLAN, ACER, EduTest &amp; HAST.
                    </Text> */}
                    <Button
                      colorScheme="cyan"
                      size="sm"
                      mt={4}
                      onClick={() => navigate("/technologies/landing-page#practice-platform")}
                    >
                      Read More
                    </Button>
                  </Box>
                </Box>
              </AspectRatio>

              <AspectRatio ratio={16 / 9} width="100%">
                <Box
                  bgImage={bandpicPlatform}
                  bgSize="contain"
                  bgPos="center"
                  bgRepeat="no-repeat"
                  bgColor="black"
                  position="relative"
                  w="100%"
                  h="100%"
                >
                  <Box
                    position="absolute"
                    bottom="5%"
                    left="5%"
                    bg="rgba(0, 0, 0, 0.6)"
                    p={6}
                    borderRadius="md"
                    maxW="lg"
                  >
{/*                     <Heading color="white" size="2xl">Eduvic Learning Platform</Heading>
                    <Text color="white" size="md" mt={2}>
                      The multi-tenant LMS coaching institutes run their entire operation on.
                    </Text> */}
                    <Button
                      colorScheme="cyan"
                      size="sm"
                      mt={4}
                      onClick={() => navigate("/technologies/landing-page#learning-platform")}
                    >
                      Read More
                    </Button>
                  </Box>
                </Box>
              </AspectRatio>

              <AspectRatio ratio={16 / 9} width="100%">
                <Box
                  bgImage={bandpic4}
                  bgSize="contain"
                  bgPos="center"
                  bgRepeat="no-repeat"
                  bgColor="black"
                  position="relative"
                  w="100%"
                  h="100%"
                >
                  <Box
                    position="absolute"
                    bottom="5%"
                    left="5%"
                    bg="rgba(0, 0, 0, 0.6)"
                    p={6}
                    borderRadius="md"
                    maxW="lg"
                  >
{/*                     <Heading color="white" size="2xl">Eduvic Assessment Engine</Heading>
                    <Text color="white" size="md" mt={2}>
                      Powering both Eduvic Practice Platform and Eduvic Learning Platform
                    </Text> */}
                    <Button
                      colorScheme="cyan"
                      size="sm"
                      mt={4}
                      onClick={() => navigate("/technologies/landing-page#assessment-engine")}
                    >
                      Read More
                    </Button>
                  </Box>
                </Box>
              </AspectRatio>
            </Slider>
          </Box>

{/*           <Box display={{ base: "block", md: "none" }} textAlign="center">
            <Heading color="white" size="2xl" mt={4} mb={2}>
              {companyConfig.brandName}
            </Heading>
            <Text fontSize="lg" color="cyan.300" mb={4}>
              Engineering the future of Learning &amp; Assessment.
            </Text>
            <Box
              width="100%"
              height="auto"
              bgImage={bandpicMob}
              bgSize="contain"
              bgPos="center"
              bgRepeat="no-repeat"
              bgColor="black"
              borderRadius="md"
              border={"1px"} borderColor={"cyan.100"}
              style={{ aspectRatio: "16/10" }}
            />
          </Box> */}
        </Box>

        {/* Intro Eduvic */}
{/*         <Box as="section" id="ourvision" bg="black" px={5} color="white">
          <Box maxW="1200px" mx="auto" textAlign="left" mb={4}>
            <Heading size="lg" mb={6} textAlign="center" color="cyan.200">
              Empowering the Future of Learning
            </Heading>
            <Text fontSize="md" color="gray.200" mb={4}>
              At <strong>{companyConfig.legalEntityName}</strong>, we believe education should be powerful, personal, and within reach for every learner and educator — no matter their location or size of institution.
            </Text>
            <Text fontSize="md" color="gray.200" mb={4}>
              Our mission is to build scalable, secure, and intuitive platforms that transform how education is delivered — from classroom to cloud.
            </Text>
            <Text fontSize="md" color="gray.200">
              We build in two directions: <strong>Eduvic Practice Platform</strong> puts exam-grade preparation directly in students' hands, and <strong>Eduvic Learning Platform</strong> gives coaching institutes the infrastructure to run online. Both are engineered by the same team, on the same assessment engine — which is why they interoperate so naturally.
            </Text>
          </Box>

          <SimpleGrid columns={{ base: 1, md: 1 }} spacing={8} maxW="1200px" mx="auto">
            <Box bg="gray.800" p={6} borderRadius="lg" boxShadow="lg">
              <Heading size="md" mb={4} color="cyan.300">
                Our Vision
              </Heading>
              <Text fontSize="sm" color="gray.300" mb={4}>
                We aim to empower educators and students alike with tools that simplify teaching, deepen practice, and make quality exam preparation genuinely accessible.
              </Text>
              <List spacing={3}>
                <ListItem>
                  <ListIcon as={CheckCircleIcon} color="cyan.300" />
                  Giving students direct, affordable access to exam-realistic practice — independent of which institute they attend.
                </ListItem>
                <ListItem>
                  <ListIcon as={CheckCircleIcon} color="cyan.300" />
                  Delivering a scalable, secure, multi-tenant Learning Management System institutes can actually run their business on.
                </ListItem>
                <ListItem>
                  <ListIcon as={CheckCircleIcon} color="cyan.300" />
                  Proving out both products ourselves, first, through Eduvic Coaching — before asking any other institute to trust them.
                </ListItem>
              </List>
            </Box>
          </SimpleGrid>
        </Box> */}

        {/* Intro Eduvic */}
        <Box as="section" id="ourvision" bg="black" px={5} color="white">
          <Box maxW="1200px" mx="auto" textAlign="left" mb={8}>
            <Heading size="lg" mb={6} textAlign="center" color="cyan.200">
              Learning and assessment, built differently.
            </Heading>

            <Text fontSize="md" color="gray.200" mb={4}>
              Eduvic is an Australian education technology startup based in Melbourne.
              We develop technology and learning products that bring together the
              platform, content, and assessment experience — with a particular focus
              on the way students, educators, and organisations actually work.
            </Text>

            <Text fontSize="md" color="gray.200" mb={4}>
              We're a small, focused team, building our products in-house and staying
              close to the problems we're trying to solve. That gives us the freedom
              to build carefully, iterate quickly, and focus on the details that
              matter.
            </Text>

            <Text fontSize="md" color="gray.200">
              Today, that work has taken shape in two products:{" "}
              <strong>Eduvic Practice Platform</strong>, combining flexible assessment
              technology with carefully authored, exam-realistic practice for
              students, and <strong>Eduvic Learning Platform</strong>, providing the
              technology organisations need to run structured learning programmes,
              from enrolment and courses through to classes, content, calendars, and
              assessment. Both products are built on the same assessment foundation —
              and both have grown from problems we have encountered ourselves.
            </Text>
          </Box>

        <SimpleGrid
          columns={{ base: 1, md: 1 }}
          spacing={8}
          maxW="1200px"
          mx="auto"
        >
          <Box
            bg="gray.800"
            p={6}
            borderRadius="lg"
            boxShadow="lg"
          >
            <Heading size="md" mb={4} color="cyan.300">
              What we're building
            </Heading>

            <Text fontSize="sm" color="gray.300" mb={6}>
              We are deliberately focused on a small number of things we believe
              we can do well — building better tools for learning, teaching, and
              assessment rather than trying to be everything to everyone.
            </Text>

            {/* Two products */}
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} mb={6}>

              {/* Practice Platform */}
              <Box
                bg="gray.900"
                borderRadius="lg"
                p={5}
                borderWidth="1px"
                borderColor="gray.700"
              >
                <Heading size="sm" color="cyan.300" mb={3}>
                  Eduvic Practice Platform
                </Heading>

                <Text fontSize="sm" color="gray.300" mb={3}>
                  A direct-to-student practice and assessment product combining
                  flexible assessment technology with carefully authored,
                  exam-realistic content.
                </Text>

                <List spacing={2}>
                  <ListItem fontSize="sm" color="gray.300">
                    <ListIcon as={CheckCircleIcon} color="cyan.300" />
                    Structured practice, mock exams, writing and manual marking,
                    analytics, and review.
                  </ListItem>

                  <ListItem fontSize="sm" color="gray.300">
                    <ListIcon as={CheckCircleIcon} color="cyan.300" />
                    Built to grow with the content — new examination areas,
                    categories, domains, and offers can be introduced through
                    the platform without requiring a new website or product build.
                  </ListItem>
                </List>
              </Box>

              {/* Learning Platform */}
              <Box
                bg="gray.900"
                borderRadius="lg"
                p={5}
                borderWidth="1px"
                borderColor="gray.700"
              >
                <Heading size="sm" color="cyan.300" mb={3}>
                  Eduvic Learning Platform
                </Heading>

                <Text fontSize="sm" color="gray.300" mb={3}>
                  A multi-tenant platform for organisations running structured
                  learning programmes, bringing the operational and learning
                  workflow into one system.
                </Text>

                <List spacing={2}>
                  <ListItem fontSize="sm" color="gray.300">
                    <ListIcon as={CheckCircleIcon} color="cyan.300" />
                    Enrolment, courses, terms, classes, batches, scheduling,
                    content, assignments, and assessments.
                  </ListItem>

                  <ListItem fontSize="sm" color="gray.300">
                    <ListIcon as={CheckCircleIcon} color="cyan.300" />
                    Designed to support different programmes and operating models
                    without requiring the underlying platform to be rebuilt.
                  </ListItem>
                </List>
              </Box>

            </SimpleGrid>

            {/* Common foundation */}
            <Box
              borderTopWidth="1px"
              borderColor="gray.700"
              pt={5}
            >
              <List spacing={3}>

                <ListItem>
                  <ListIcon as={CheckCircleIcon} color="cyan.300" />
                  <strong>One assessment foundation</strong> — both products share
                  the same assessment technology, allowing the Learning Platform
                  and direct-to-student Practice experience to operate independently
                  while benefiting from the same underlying engineering.
                </ListItem>

                <ListItem>
                  <ListIcon as={CheckCircleIcon} color="cyan.300" />
                  <strong>We use what we build</strong> — Eduvic Coaching is our
                  own operating environment and first real customer of the
                  technology, using the Learning Platform to run structured
                  programmes and providing guided preparation alongside access
                  to relevant practice through the Practice Platform.
                </ListItem>

              </List>
            </Box>
          </Box>
        </SimpleGrid>

        </Box>

        {/* Value Proposition Section */}
        <Box maxW="1200px" mx="auto" py={10} px={5}>
          <EduvicUSP />
        </Box>

        {/* Case Studies */}
        <Box as="section" id="casestudy" maxW="1200px" mx="auto" px={5} py={10}>
          <Heading size="lg" mb={4} color="cyan.300" textAlign="center">
            Case Studies
          </Heading>

          <Text fontSize="sm" color="gray.300" mb={6} textAlign="center">
            Both of these were run in production on Eduvic Learning Platform, for Eduvic Coaching — our own institute, and the first real-world proof of the product.
          </Text>

          <Box bg="gray.800" borderRadius="lg" boxShadow="lg" p={8}>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} justifyItems="center">
              <CaseStudyCard id="eduvic-assess" mode="light" />
              <CaseStudyCard id="eduvic-content-delivery" mode="light" />
            </SimpleGrid>
          </Box>
        </Box>

        {/* ── Assessment Engine ── */}
<Box
  as="section"
  id="assessment-engine"
  maxW="1200px"
  mx="auto"
  px={5}
  py={12}
  bg="gray.950"
>
  <Heading
    size="lg"
    mb={3}
    textAlign="center"
    color="cyan.200"
  >
    Assessment Engine
  </Heading>

  <Text
    fontSize="sm"
    color="gray.400"
    textAlign="center"
    mb={10}
    maxW="760px"
    mx="auto"
  >
    A shared assessment technology foundation powering both Eduvic
    platforms.
  </Text>

  <Box
    maxW="1000px"
    mx="auto"
    bg="gray.900"
    borderRadius="2xl"
    borderWidth="1px"
    borderColor="gray.700"
    p={{ base: 6, md: 10 }}
  >
    <Text
      fontSize={{ base: "md", md: "lg" }}
      color="gray.200"
      lineHeight="1.9"
      textAlign="center"
      mb={10}
    >
      Eduvic's assessment technology supports question authoring,
      examinations, practice attempts, scoring, marking and performance
      analytics across both products — while allowing each platform to
      maintain the workflows and access controls appropriate to its users.
    </Text>

    <SimpleGrid
      columns={{ base: 1, md: 2, lg: 3 }}
      spacing={5}
    >
      <ProductAttributeCard
        icon={FileCheck2}
        title="Question & Assessment Content"
        points={[
          "Structured question sets shared across learning and practice.",
          "Multiple question formats and assessment configurations.",
        ]}
        accentColor="cyan.300"
      />

      <ProductAttributeCard
        icon={BarChart3}
        title="Scoring & Marking"
        points={[
          "Automated scoring with support for manual assessment workflows.",
          "Consistent scoring logic across examinations and practice.",
        ]}
        accentColor="cyan.300"
      />

      <ProductAttributeCard
        icon={TrendingUp}
        title="Performance Analytics"
        points={[
          "Detailed results and topic-level performance analysis.",
          "Results designed to identify strengths and areas requiring further work.",
        ]}
        accentColor="cyan.300"
      />

      <ProductAttributeCard
        icon={Shuffle}
        title="Practice & Examinations"
        points={[
          "Supports both scheduled examinations and independent practice attempts.",
          "Assessment behaviour adapts to the context of each product.",
        ]}
        accentColor="cyan.300"
      />

      <ProductAttributeCard
        icon={Layers}
        title="Shared Technology, Separate Workflows"
        points={[
          "Common assessment capabilities are reused where appropriate.",
          "B2B examinations and B2C practice retain their own domain workflows.",
        ]}
        accentColor="cyan.300"
      />

      <ProductAttributeCard
        icon={ShieldCheck}
        title="Built for Both Platforms"
        points={[
          "Designed to maintain consistent assessment capabilities across B2B and B2C.",
          "Platform-specific access and authorization remain separated.",
        ]}
        accentColor="cyan.300"
      />
    </SimpleGrid>

    <Text
      fontSize="xs"
      color="gray.500"
      textAlign="center"
      mt={8}
      maxW="760px"
      mx="auto"
    >
      Shared assessment capabilities are deliberately reused where the
      underlying requirements are common, while product-specific workflows
      remain independently controlled.
    </Text>
  </Box>
</Box>

        {/* Our Products — exactly two products, no subsidiary card here */}
        <Box as="section" id="ourproducts" maxW="1200px" mx="auto" px={5} py={10} bg="black">
          <Heading size="lg" mb={3} textAlign="center" color="cyan.200">
            Our Products
          </Heading>
          <Text fontSize="sm" color="gray.400" textAlign="center" mb={12} maxW="700px" mx="auto">
            Two products, one engine underneath.
          </Text>

            {/* ── Eduvic Practice Platform (B2C) ── */}
          <Box id="practice-platform" mb={20}>
            <HStack mb={2} spacing={3} justify="center" flexWrap="wrap" >
              <Heading size="lg" color="cyan.300" textAlign="center">
                Eduvic Practice Platform
              </Heading>
              <Badge colorScheme="blue" fontSize="sm">B2C</Badge>
            </HStack>
            <Text fontSize="sm" color="gray.400" textAlign="center" mb={2}>
              Direct-to-student practice testing for competitive examinations
            </Text>
            <Text fontSize="sm" color="gray.300" textAlign="center" mb={8} maxW="700px" mx="auto" fontStyle="italic">
              Selective Entry, NAPLAN, ACER, EduTest, and HAST preparation — built as a serious assessment product, not a quiz app.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={5}>
              {practiceAttributes.map((attr, idx) => (
                <ProductAttributeCard
                  key={idx}
                  icon={attr.icon}
                  title={attr.title}
                  points={attr.points}
                  accentColor="blue.300"
                />
              ))}
            </SimpleGrid>
            
            {/* NEW — Practice Platform CTA */}
            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="blue"
                size="md"
                rightIcon={<Icon as={ArrowRightIcon} />}
                onClick={() => window.open('/practice/', '_blank', 'noopener,noreferrer')}
              >
                Explore Eduvic Practice Platform
              </Button>
            </Box>

          </Box>

          {/* ── Eduvic Learning Platform (B2B) ── */}
          <Box id="learning-platform" mb={10}>
            <HStack mb={2} spacing={3} justify="center" flexWrap="wrap">
              <Heading size="lg" color="cyan.300" textAlign="center">
                Eduvic Learning Platform
              </Heading>
              <Badge colorScheme="purple" fontSize="sm">B2B</Badge>
            </HStack>

          <Text fontSize="sm" color="gray.400" textAlign="center" mb={2}>
            Multi-tenant Learning Management System for organisations that run structured learning programmes
          </Text>

          <Text
            fontSize="sm"
            color="gray.300"
            textAlign="center"
            mb={8}
            maxW="700px"
            mx="auto"
            fontStyle="italic"
          >
            A shared platform for running courses, classes, batches, content,
            assessments, and exams — with the flexibility to support different
            learning models and delivery formats.
          </Text>

            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={5} mb={10}>
              {learningAttributes.map((attr, idx) => (
                <ProductAttributeCard
                  key={idx}
                  icon={attr.icon}
                  title={attr.title}
                  points={attr.points}
                  accentColor="purple.300"
                />
              ))}
            </SimpleGrid>

            {/* Two ways to engage — Tier 1 and Tier 2 */}
            <Text
              fontSize="sm"
              fontWeight="bold"
              color="gray.400"
              textAlign="center"
              mb={5}
            >
              Two ways to get started
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
              <Box
                bg="gray.900"
                borderRadius="lg"
                p={6}
                borderWidth="1px"
                borderColor="gray.700"
              >
                <Badge colorScheme="teal" mb={3}>
                  Managed Exam Content
                </Badge>

                <Heading size="sm" color="white" mb={3}>
                  Tier 1 — We author, you deliver
                </Heading>

                <Text fontSize="sm" color="gray.300" mb={3}>
                  Send us your existing question sets or teaching material — Word
                  docs, past papers, whatever you already have. We handle authoring
                  and upload; you run exams on the platform under a monthly exam
                  allowance.
                </Text>

                <Text fontSize="xs" color="gray.500">
                  The simplest way to get your institute assessing online, with no
                  content-management overhead on your end.
                </Text>
              </Box>

              <Box
                bg="gray.900"
                borderRadius="lg"
                p={6}
                borderWidth="1px"
                borderColor="gray.700"
              >
                <Badge colorScheme="orange" mb={3}>
                  Full Authoring
                </Badge>

                <Heading size="sm" color="white" mb={3}>
                  Tier 2 — Your team, full control
                </Heading>

                <Text fontSize="sm" color="gray.300" mb={3}>
                  For institutes with their own established content and pedagogy.
                  Your team gets direct question authoring, bulk upload, and full
                  exam-creation control — your content stays entirely yours.
                </Text>

                <Text fontSize="xs" color="gray.500">
                  A sales conversation, not a self-serve signup — we'll walk through
                  fit and scope together.
                </Text>
              </Box>
            </SimpleGrid>

            {/* Learning Platform entry point */}
            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="purple"
                size="md"
                rightIcon={<Icon as={ArrowRightIcon} />}
                onClick={() =>
                  window.open('/platform/', '_blank', 'noopener,noreferrer')
                }
              >
                Explore Eduvic Learning Platform
              </Button>
            </Box>
          </Box>

        </Box>


{/* Eduvic Coaching — closing segment, standalone, after Products */}
<Box as="section" id="coaching" maxW="1200px" mx="auto" px={5} py={10}>
  <Box
    bg="gray.900"
    borderRadius="lg"
    p={8}
    borderWidth="1px"
    borderColor="green.700"
  >
    <HStack mb={3} spacing={3} justify="center" flexWrap="wrap">
      <Icon as={GraduationCap} boxSize={6} color="green.300" />
      <Heading size="lg" color="cyan.300">
        Eduvic Coaching
      </Heading>
      <Badge colorScheme="green" fontSize="sm">
        Online Education Service
      </Badge>
    </HStack>

    <Text fontSize="sm" color="gray.400" mb={4}>
      An online education service within the Eduvic business, and the first tenant of the Eduvic Learning Platform.
    </Text>

    <Text fontSize="sm" color="gray.300" mb={4}>
      Eduvic Coaching delivers guided, online exam preparation using the Eduvic Learning
      Platform, with tutor-led programs, online classes, regular mock examinations and
      access to the Eduvic Practice Platform. It is both a real coaching business and
      our own institute-scale proving ground: every enrolment workflow, exam run, and
      marking queue in the case studies above happened here first.
    </Text>

    <Text fontSize="sm" color="gray.300">
      <ArrowRightIcon mx={"2px"} />
      For institutes evaluating Eduvic Learning Platform, Eduvic Coaching is the
      reference implementation — not a demo environment.
    </Text>

    <Box textAlign="center" mt={6}>
      <Button
        colorScheme="green"
        size="md"
        rightIcon={<Icon as={ArrowRightIcon} />}
        onClick={() => window.open('/coaching/', '_blank', 'noopener,noreferrer')}
      >
        Visit Eduvic Coaching
      </Button>
    </Box>
  </Box>
</Box>



        <Box as="section" id="contact" maxW="1200px" mx="auto" px={5} mb={10}>
          <Heading size="lg" mb={6} textAlign="center" color="cyan.200">
            Get in Touch
          </Heading>

          <Text fontSize="sm" color="gray.300" mb={8} textAlign="left">
            Whether you're an institute evaluating Eduvic Learning Platform, a student or parent exploring Eduvic Practice Platform, or simply want to know more about {companyConfig.legalEntityName} — we're glad to hear from you.
          </Text>

          <Box
            maxW="1200px"
            mx="auto"
            p={6}
            bg="gray.800"
            borderRadius="md"
            boxShadow="lg"
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            alignItems={{ base: "center", md: "flex-start" }}
            textAlign={{ base: "center", md: "left" }}
            gap={6}
          >
            <Box flex="1">
              <Heading size="md" mb={2} color="cyan.200">
                Reach out to us
              </Heading>
              <Text fontSize="sm" color="gray.400" mb={4}>
                Write to us at
              </Text>
              <Text fontSize="sm" color="gray.300" whiteSpace="pre-wrap">
                <Link href={`mailto:${companyConfig.supportEmail}`} color="cyan.300" isExternal>
                  {companyConfig.supportEmail}
                </Link>
              </Text>
            </Box>

            <Box flex="1">
              <Heading size="md" mb={2} color="cyan.200">
                Call Us
              </Heading>
              <Text fontSize="sm" color="gray.400" mb={4}>
                We're available during business hours to take your call:
              </Text>
              <Text fontSize="sm" color="gray.300">
                {contactusPhone}
              </Text>
            </Box>
          </Box>
        </Box>

      </Box>
    </TechLayout>
  );
};

export default LandingPageTech;
